<template>
  <div class="a">
    <top></top>
    <navs></navs>
    <div class="content">
      <div class="time">
        <div class="cont_left">
          <div class="cont">
            <div class="cont_a">
              <div class="bule"></div>
              <div class="p">{{ name }}</div>
            </div>
            <div class="cont_b">
              <div></div>
            </div>
          </div>
          <div class="sj">
            <div v-for="(item, index) in list" :key="index" class="xs" @click="lh(item.id)">

              <el-button type="text">
                <div class="xs_top">
                  <img :src="item.placard" alt="" height="218px" width="218px">
                </div>
                <div class="xs_bottom">
                  <div class="center">
                    {{ item.name }}
                  </div>
                </div>
              </el-button>
            </div>


          </div>
        </div>
        <div class="cont_right">
          <div class="cont_a">
            <div class="bule"></div>
            <div class="p">其他专辑</div>
          </div>
          <div class="directory">
            <div v-for="(item, index) in lists" :key="index" class="album" @click="album(item.id)">
              <img :src="item.placard" alt="" height="55px" width="55px">
              <div class="album_cont">
                <div class="album_title">
                  <p>{{ item.name }}</p>
                  <p>></p>
                </div>
                <div class="album_text">{{ item.briefInfo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div
      style=" width: 100%; background: #fff; height: 60px; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
      <el-pagination :current-page="currentPage" :page-size="100" :page-sizes="[10, 20, 30, 40]" :total="total"
                     layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <el-dialog :visible.sync="dialogFormVisible" title="手机号登录">
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth" label="手机号码">
          <el-input v-model="form.phone" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="图片验证" :label-width="formLabelWidth">
            <el-input v-model="form.captcha" autocomplete="off" style="width: 300px;"></el-input>
            <img :src="img" alt="" @click="captcha" style="height: 20px;width: 100px;">
        </el-form-item> -->
        <el-form-item :label-width="formLabelWidth" label="短信验证">
          <el-input v-model="form.dx" autocomplete="off" style="width: 300px;"></el-input>
          <el-button :disabled="countdown > 0" @click="startCountdown">
            {{ countdown > 0 ? countdown + '秒' : '发送验证码' }}
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">登 录</el-button>
      </div>
    </el-dialog>
    <bottom></bottom>
  </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"
import {praise, getyz} from "../api/index"

export default {
  components: {
    top,
    bottom,
    navs
  },
  data() {
    return {
      list: [],
      lists: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        phone: '',
        captcha: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''

      },
      formLabelWidth: '120px',
      img: "https://www.jnccljh.com/api/images",
      name: "",
      countdown: 0,
      timer: null,
      aid: "",
      total: 0, // 总数量
      pageNo: 1, // 当前页数
      pageSize: 9, // 当前显示数量
      currentPage: 1,
    }
  },
  created() {
    this.aid = this.$route.query.id
    console.log(this.aid)
    axios({
      method: "GET",
      url: "https://www.jnccljh.com/api/records/pages",
      params: {
        "albumId": this.$route.query.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
    }).then(res => {
      this.list = res.data.data.records
      this.total = res.data.data.total
    })
    praise(1, 999).then(res => {
      this.lists = res.data.data.records
    })
    axios({
      method: "GET",
      url: "https://www.jnccljh.com/api/albums/" + this.$route.query.id
    }).then(res => {
      console.log(res)
      this.name = res.data.data.name
    })
  },
  methods: {

    /**
     * 页码改变触发后
     * **/
    handleCurrentChange(val) {
      console.log(val, '页码改变触发后')
      this.pageNo = val
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/records/pages",
        params: {
          "albumId": this.$route.query.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
      }).then(res => {
        this.list = res.data.data.records
        this.total = res.data.data.total
      })


    },
    /**
     * 每条多少页改变后
     * **/
    handleSizeChange(val) {
      console.log(val, '页数改变后')
      this.pageSize = val
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/records/pages",
        params: {
          "albumId": this.$route.query.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
      }).then(res => {
        this.list = res.data.data.records
        this.total = res.data.data.total
      })


    },
    lh(item) {

      if (localStorage.getItem("token") != null) {
        this.$router.push({path: "/lh", query: {id: item, aid: this.aid}})
      } else {
        this.dialogFormVisible = true
      }
    },
    submit() {
      this.dialogFormVisible = false
      const data = {"account": this.form.phone, thirdType: "SMS", mobileText: this.form.dx};
      axios.post('https://www.jnccljh.com/api/login', data).then(res => {
        console.log(res)
        if (res.data.data.accessToken != "") {
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          localStorage.setItem("token", res.data.data.accessToken)
        }
      })
    },
    getyz() {

      // getyz({

      //         "captchaCode": this.form.captcha
      // }).then(res=>{
      //     console.log(res)
      // })
      const data = {"account": this.form.phone};
      axios.post('https://www.jnccljh.com/api/sms', data);
      // axios({
      //     method: "POST",
      //     url: "https://www.jnccljh.com/api/sms",
      //     params: {
      //         "account": this.form.phone,
      //         "captchaCode": this.form.captcha
      //     }
      // }).then(res => {
      //     console.log(res)

      // })
    },
    // lh(){
    //     this.$router.push({path:"/lh"})
    // },
    captcha() {
      axios({
        method: "GET",
        url: " https://www.jnccljh.com/api/image",
        params: {
          "account": "18900000000",
        }
      }).then(res => {
        console.log(res)
        this.list = res.data.data.records
      })
    },
    album(item) {
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/records/pages",
        params: {
          "albumId": item,
        }
      }).then(res => {
        console.log(res)
        this.list = res.data.data.records
      })
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/albums/" + item
      }).then(res => {
        console.log(res)
        this.name = res.data.data.name
      })
    },


  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  watch: {
    countdown: {
      handler(newVal) {
        this.countdown = newVal
      }
    }
  }
}
</script>
<style scoped>
.a {
  width: 100%;
  /* height: 100vh; */
  margin: 0;
  padding: 0;
  background-color: #F7F7F7;
}

.content {
  width: 100%;
  /* height: 480px; */
  /* height: 1330px; */
  background-image: url(../image/back.png);
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time {
  width: 70%;
  margin: 0 auto;
  /* height: 1330px; */
  /* background-color: #F7F7F7; */
  display: flex;
  justify-content: space-between;
}

.bule {
  width: 5px;
  height: 16px;
  background: #1463FF;
}

.p {
  margin-left: 5px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
  line-height: 17px;
  font-style: normal;
}

.cont {
  width: 100%;
  margin: 0 auto;

}

.cont_a {
  height: 74px;
  display: flex;
  align-items: center;
}

.sj {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

}

.xs {
  width: 30%;
  height: 264px;
  margin-bottom: 30px;
  margin-right: 20px;
}

.xs_top {
  width: 100%;
}

.xs_bottom {
  height: 46px;
  /* width: 100%; */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
}

.xs:hover {
  width: 30%;
  height: 264px;
  margin-bottom: 30px;
  margin-right: 20px;
  box-shadow: 4px 4 6px 0px rgba(75, 98, 168, 0.53);
  transform: translateY(-5px);
  /* margin-bottom: 46px; */
}

.xs_bottom:hover {
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1463FF;
  color: #FFFFFF;
}

.center {
  height: 46px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: .1375rem;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.cont_left {
  width: 68%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cont_right {
  width: 28%;
}

.directory {
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 50px;

  overflow-y: auto;
  /* 启用垂直滚动 */
  /* height: 800px; */
  height: auto;
  max-height: 410px;
}

.album {
  width: 80%;
  margin: 0 auto;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.album_cont {
  width: 65%;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.album_title {
  display: flex;
  justify-content: space-between;
}

.album_text {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.album:hover {
  color: #1463FF;
}
</style>



// WEBPACK FOOTER //
// src/views/zmyzlh.vue